// src/pages/APropos.js
import React from 'react';
import '../styles/APropos.css';

const APropos = () => {
    return (
        <div className="apropos-container">
            <h1 className="title">Naninan : L'Épopée Cinématographique</h1>

            <div className="scene">
                <h2>🎬 Scène 1 : Les Racines de la Passion</h2>
                <p><strong>Extérieur – Nuit – Une petite salle de cinéma de quartier</strong></p>
                <p>Dans la douce obscurité d'une salle de cinéma, un jeune passionné nommé Kilédehn est absorbé par les images lumineuses qui dansent sur l'écran. Chaque film est pour lui une nouvelle aventure, une fenêtre ouverte sur des mondes inconnus.</p>
                <blockquote>
                    <em>"Depuis son enfance, Kilédehn trouve refuge dans les salles obscures, où les histoires prennent vie et les émotions se déploient."</em>
                </blockquote>
            </div>

            <div className="scene">
                <h2>💡 Scène 2 : La Prise de Conscience</h2>
                <p><strong>Intérieur – Jour – Appartement de Kilédehn</strong></p>
                <p>Entouré de piles de magazines de cinéma et de billets de films, Kilédehn tente de planifier sa prochaine sortie. Il réalise alors la difficulté de trouver des informations centralisées sur les projections, les événements cinématographiques et les avis des spectateurs.</p>
                <blockquote>
                    <em>Kilédehn (réfléchissant) : "Pourquoi n'existe-t-il pas une plateforme unique où les passionnés de cinéma pourraient trouver toutes ces informations ?"</em>
                </blockquote>
            </div>

            <div className="scene">
                <h2>🚀 Scène 3 : La Genèse de Naninan</h2>
                <p><strong>Intérieur – Nuit – Bureau de Kilédehn</strong></p>
                <p>Déterminé à combler ce vide, Kilédehn esquisse les premières ébauches d'une plateforme dédiée au cinéma. Il imagine un espace où les utilisateurs pourraient découvrir les dernières sorties, partager leurs avis et être informés des événements cinématographiques à venir.</p>
                <blockquote>
                    <em>"C'est ainsi que naquit l'idée de Naninan, une plateforme pensée par et pour les amoureux du cinéma."</em>
                </blockquote>
            </div>

            <div className="scene">
                <h2>🤝 Scène 4 : L'Alliance avec ADE</h2>
                <p><strong>Intérieur – Jour – Salle de réunion</strong></p>
                <p>Kilédehn présente son projet à l'équipe d'ADE, une entreprise reconnue pour son expertise en développement de plateformes innovantes. Séduite par la vision d'Kilédehn, l'équipe décide de s'associer à lui pour donner vie à Naninan.</p>
                <blockquote>
                    <em>Chef de projet ADE : "Ensemble, nous allons créer une expérience unique pour tous les cinéphiles."</em>
                </blockquote>
            </div>

            <div className="scene">
                <h2>🎉 Scène 5 : Le Lancement de Naninan</h2>
                <p><strong>Extérieur – Soir – Devanture d'un cinéma avec une bannière "Lancement de Naninan"</strong></p>
                <p>Après des mois de collaboration, Naninan est enfin prêt à être dévoilé au public. La plateforme offre désormais :</p>
                <ul>
                    <li>📅 Un calendrier des sorties de films avec les lieux et horaires des projections.</li>
                    <li>📝 Une section dédiée aux avis et critiques des utilisateurs.</li>
                    <li>🎭 Des informations sur les événements et festivals cinématographiques.</li>
                </ul>
                <blockquote>
                    <em>"Naninan est plus qu'une simple plateforme ; c'est une communauté où chaque passionné peut partager, découvrir et célébrer le cinéma."</em>
                </blockquote>
            </div>

            <div className="scene">
                <h2>🔮 Scène 6 : L'Avenir de Naninan</h2>
                <p><strong>Intérieur – Jour – Bureau de Naninan</strong></p>
                <p>L'équipe, désormais composée d'Kilédehn, des membres d'ADE et de nouveaux talents, travaille sans relâche pour enrichir la plateforme. Ils envisagent d'ajouter des fonctionnalités telles que des interviews exclusives, des analyses approfondies et des recommandations personnalisées.</p>
                <blockquote>
                    <em>Kilédehn (souriant) : "Ce n'est que le début de l'aventure. Le cinéma évolue, et Naninan évoluera avec lui, toujours au service des passionnés."</em>
                </blockquote>
            </div>

            <p className="note">
                <strong>Note :</strong> Ce scénario est une représentation fictive de la genèse de Naninan. Toute ressemblance avec des personnes ou des événements réels serait purement fortuite.
            </p>
        </div>
    );
};

export default APropos;
